export class HttpStatusCodes {
    public static FOUND: number = 302;
    public static BAD_REQUEST: number = 400;
    public static UNAUTHORIZED: number = 401;
    public static FORBIDDEN: number = 403;
    public static NOT_FOUND: number = 404;
    public static INTERNAL_SERVER_ERROR: number = 500;
    public static NOT_IMPLEMENTED: number = 501;
}
